import classNames from '@sindresorhus/class-names';

import styles from './StoriesLoader.module.scss';

const Item = () => {
  return (
    <div className={styles.itemWrapper}>
      <div className={styles.circle} />
      <div className={styles.line} />
      <div className={styles.subline} />
    </div>
  );
};

export const StoriesLoader = ({noMargin}: {noMargin?: boolean}) => {
  const Circles = Array(10).fill(Item);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapper__noMargin]: noMargin,
      })}
    >
      {Circles.map((Item, index) => (
        <Item key={index} />
      ))}
    </div>
  );
};
